import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsSelectDocumentsScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.SelectDocuments />
    </View>
  );
};

export default PreProposalsSelectDocumentsScreen;
